const cleanUpSuperfanData = superfans => superfans.map(superfan => ({
  email: superfan.email || 'info@superfan.world',
  firstName: superfan.firstName || '',
  lastName: superfan.lastName || '',
  id: superfan.id || '',
}))

export default cleanUpSuperfanData
